import AnalyticsTwoToneIcon from '@mui/icons-material/AnalyticsTwoTone';
import ReceiptTwoToneIcon from '@mui/icons-material/ReceiptTwoTone';
import AttachMoneyTwoToneIcon from '@mui/icons-material/AttachMoneyTwoTone'
import BackupTableTwoToneIcon from '@mui/icons-material/BackupTableTwoTone';
import BuildTwoToneIcon from '@mui/icons-material/BuildTwoTone'

const menuItems = [
  {
    heading: '',
    items: [
      {
        name: 'Dashboard',
        icon: AnalyticsTwoToneIcon,
        link: '/dashboards/home',
        display: 'always'
      },
      {
        name: 'Connexion au CRM',
        icon: BuildTwoToneIcon,
        link: '/management/pipelines/list',
        display: 'admin'
      },
      {
        name: 'Commissions',
        icon: AttachMoneyTwoToneIcon,
        link: '/management/spiffs/list',
        display: 'always'
      },
      {
        name: 'Modèles',
        icon: BackupTableTwoToneIcon,
        link: '/management/templates/list',
        display: 'admin'
      },
      {
        name: 'Paie',
        icon: ReceiptTwoToneIcon,
        link: '/management/payouts/list',
        display: 'admin'
      },
    ]
  }
];

export default menuItems;
